/**
 * KWC · Sticky Buy Bar
 * ---------------------------------------------------------------------------
 * Presentation only; no second variant system and no second cart:
 *   - The "Buy now · <price>" label mirrors Horizon's own <product-price>.
 *     Horizon swaps that element's priceContainer for a new one on every
 *     variant change, so the observer watches the stable <product-price> host
 *     and re-reads the current price each time.
 *   - Visibility is driven by an IntersectionObserver on the main buy area.
 *   - The button is a [data-kwc-buy-now] button: assets/kwc-buy-now.js (shared
 *     with the Buy now under Add to cart) adds the selected variant once and
 *     goes to checkout, and handles "Sold out", the spinner and the error.
 *
 * Vanilla, dependency-free, and self-contained. Safe if any hook is missing.
 */
(function () {
  var bar = document.querySelector('[data-kwc-sbb]');
  if (!bar) return;

  var scope = document.querySelector('main[data-template="product"]') || document;
  var priceHost =
    scope.querySelector('.product-details product-price') ||
    scope.querySelector('product-price');
  var nativeAtc = scope.querySelector('[ref="addToCartButton"]');
  var trigger =
    scope.querySelector('.buy-buttons-block') ||
    (nativeAtc && nativeAtc.closest('add-to-cart-component, product-form-component'));

  var barPrice = bar.querySelector('[data-kwc-sbb-price]');

  /* --- Price sync: copy Horizon's current price (not the compare-at) ------ */
  function currentPriceText() {
    if (!priceHost) return '';
    var container = priceHost.querySelector('[ref="priceContainer"]') || priceHost;
    var current = container.querySelector('.price') || container;
    var copy = current.cloneNode(true);
    copy.querySelectorAll('.visually-hidden').forEach(function (node) {
      node.remove();
    });
    return copy.textContent.replace(/\s+/g, ' ').trim();
  }

  function syncPrice() {
    if (!barPrice) return;
    var text = currentPriceText();
    if (text) barPrice.textContent = text;
  }
  syncPrice();
  if (priceHost && 'MutationObserver' in window) {
    new MutationObserver(syncPrice).observe(priceHost, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  /* --- Visibility: show once the main buy area has scrolled ABOVE view --- */
  if (trigger && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = entry.boundingClientRect.top < 0;
          if (!entry.isIntersecting && scrolledPast) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0 }
    );
    io.observe(trigger);
  }
})();
